"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function countDataPages(dataHex) {
    return Math.max(Math.ceil((dataHex.length / 16) / 32), 1);
}
exports.countDataPages = countDataPages;
//# sourceMappingURL=countDataPages.js.map